// Prolific study config (separate from original labeling config)
export default {
  IDLE_TIMEOUT_SECONDS: 45,
  MAIN_STUDY_QUESTION_COUNT: 150,
  MAIN_STUDY_DURATION_SECONDS: 3600,
  PRACTICE_PASS_THRESHOLD: 3,
  SCREENING_PASS_THRESHOLD: 4,
  TRAINING_PASS_THRESHOLD: 4,
  MENTAL_EFFORT_MAX: 9,
  PROLIFIC_COMPLETION_URL: 'https://app.prolific.com/submissions/complete?cc=CV811175',
};
